import { Form, Modal, notification, Select } from 'antd'
import { t } from 'i18next'
import { VacationModel } from 'models/workSchedule';
import React, { useEffect } from 'react'
import { useQueryClient } from 'react-query';
import UseAcceptOrRejectVacation from 'hooks/query/workSchedule/UseAcceptOrRejectVacation';

interface UpdateVacationProps {
  openApproveVacation: boolean;
  setOpenApproveVacation: (openApproveVacation: boolean) => void;
  selectedVacation: VacationModel | null
  setSelectedVacation: (selectedVacation: VacationModel | null) => void
}

const vacationStatus: {key: string; value: number}[] = [
  {
    key: 'pending',
    value: 1
  },
  {
    key: 'approved', 
    value: 2
  },
  {
    key: "rejected",
    value: 3
  },
]

const UpdateVacationStatus = ({openApproveVacation, setOpenApproveVacation, selectedVacation, setSelectedVacation}: UpdateVacationProps) => {
    const [form] = Form.useForm();
    const queryClient = useQueryClient()
    const responseAcceptOrRejectVacation = UseAcceptOrRejectVacation();

    useEffect(() => {
    if (!openApproveVacation) return;
    if (selectedVacation) {
        form.setFieldsValue({
            status: selectedVacation?.status
        });
    } 
    else {
        form.resetFields();
    }
    }, [selectedVacation, openApproveVacation, form]);

    const onFinish = async (values: any) => {
        console.log(values);
        if (!selectedVacation || values.status === undefined) return;
        else {
            responseAcceptOrRejectVacation
                .mutateAsync({ vacationId: selectedVacation?.id, status: values.status })
                .then(() => {
                queryClient.invalidateQueries({
                queryKey: ['vacation-list'],
                });
                notification.open({
                    type: 'success',
                    message: t('vacation_status_updated_successfully'),
                });
                handleClose();
                })
                .catch(() => {});
        }
    }

    const handleClose = () => {
        setOpenApproveVacation(false);
        setSelectedVacation(null);
        form.resetFields();
    };
    return (
        <Modal
            title={t('approve_or_reject_vacation')}
            open={openApproveVacation}
            centered
            destroyOnClose
            onCancel={handleClose}
            closable={{ 'aria-label': 'Custom Close Button' }}
            okButtonProps={{ loading: responseAcceptOrRejectVacation.isLoading}}
            onOk={() => {form.submit()}}>
            <Form form={form} onFinish={onFinish} labelCol={{ span: 24 }}>
                <div style={{marginBottom: "30px"}}>
                    <p>{t("vacation_status")}</p>
                    <Form.Item
                        name="status"
                    >
                        <Select
                            allowClear
                            style={{ width: '100%', height: '40px' }}
                            placeholder={t("please_select")}
                            options={vacationStatus.map((element) => ({ label: t(element.key), value: element.value }))}
                        />
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    )
}

export default UpdateVacationStatus